/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FetchOrderRequest } from '../../models/fetch-order-request';

export interface GetOrderByTourOperatorAndLastName$Params {
      body: FetchOrderRequest
}

export function getOrderByTourOperatorAndLastName(http: HttpClient, rootUrl: string, params: GetOrderByTourOperatorAndLastName$Params, context?: HttpContext): Observable<DapiHttpResponse<void>> {
  const rb = new DapiRequestBuilder(rootUrl, getOrderByTourOperatorAndLastName.PATH, 'post');

  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as DapiHttpResponse<void>;
    }),
    catchErrorAsJson()
  );
}

getOrderByTourOperatorAndLastName.PATH = '/api/v2/order/get-order-tour-operator';
